// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8fafc;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

* {
  box-sizing: border-box;
}

/***********************/
/* MainLayout CSS */
/***********************/

.main-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  background-color: #f1f5f9;
  min-height: 100vh;
  padding: 0;
}

/***********************/
/* Sidebar CSS */
/***********************/

.sidebar .MuiDrawer-paper {
  background: #4a5568 !important;
  color: white !important;
  border-right: none !important;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px;
  background: #2d3748;
  border-bottom: 1px solid #4a5568;
}

.sidebar-logo {
  color: #6366f1 !important;
  font-size: 28px !important;
}

.sidebar-title {
  font-size: 20px !important;
  font-weight: 700 !important;
  color: white !important;
  margin: 0 !important;
  line-height: 1.2 !important;
}

.sidebar-subtitle {
  font-size: 14px !important;
  color: #a0aec0 !important;
  margin: 0 !important;
  line-height: 1 !important;
}

.sidebar-menu {
  padding: 16px 0 !important;
}

.sidebar-menu-item {
  margin: 4px 16px !important;
  border-radius: 8px !important;
  color: #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.sidebar-menu-item:hover {
  background-color: #2d3748 !important;
  color: white !important;
}

.sidebar-menu-item.active {
  background-color: #6366f1 !important;
  color: white !important;
}

.sidebar-menu-item.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.sidebar-menu-icon {
  color: inherit !important;
  min-width: 40px !important;
}

.sidebar-menu-text .MuiTypography-root {
  font-size: 14px !important;
  font-weight: 500 !important;
}

/***********************/
/* Overview CSS */
/***********************/

.overview {
  padding: 32px;
  background-color: #f1f5f9;
  min-height: 100vh;
  margin: 0;
}

.overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.overview-title {
  font-size: 32px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  margin: 0 !important;
}

.overview-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.agent-selector {
  color: #64748b !important;
  font-size: 14px !important;
}

.refresh-button {
  background-color: #6366f1 !important;
  color: white !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

.refresh-button:hover {
  background-color: #5856eb !important;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e2e8f0 !important;
  transition: all 0.2s ease !important;
}

.stat-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

.stat-card.total-agents .stat-number {
  color: #64748b;
  font-size: 48px;
  font-weight: 700;
  margin: 0;
}

.stat-card.active-agents {
  border-left: 4px solid #10b981 !important;
}

.stat-card.active-agents .stat-icon {
  color: #10b981 !important;
}

.stat-card.active-agents .stat-number {
  color: #10b981;
  font-size: 48px;
  font-weight: 700;
  margin: 0;
}

.stat-card.security-alerts {
  border-left: 4px solid #f59e0b !important;
}

.stat-card.security-alerts .stat-icon {
  color: #f59e0b !important;
}

.stat-card.security-alerts .stat-number {
  color: #f59e0b;
  font-size: 48px;
  font-weight: 700;
  margin: 0;
}

.stat-card.disconnected {
  border-left: 4px solid #ef4444 !important;
}

.stat-card.disconnected .stat-number {
  color: #ef4444;
  font-size: 48px;
  font-weight: 700;
  margin: 0;
}

.stat-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px;
}

.stat-icon {
  font-size: 24px !important;
  margin-bottom: 8px;
}

.stat-label {
  color: #64748b !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin: 8px 0 0 0 !important;
}

.charts-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.chart-card {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e2e8f0 !important;
}

.chart-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  margin-bottom: 16px !important;
}

.chart-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 2px dashed #cbd5e1;
}

.pie-chart-container {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.pie-chart-container:hover {
  transform: translateY(-2px);
}

.pie-chart-container .recharts-legend-wrapper {
  padding-top: 20px !important;
}

.pie-chart-container .recharts-legend-item-text {
  color: #1e293b !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.pie-chart-container .recharts-pie-sector {
  transition: all 0.3s ease !important;
  cursor: default !important;
}

.pie-chart-container .recharts-pie-sector:hover {
  filter: brightness(1.1);
  transform: scale(1.02);
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.event-item {
  padding: 12px;
  background-color: #f8fafc;
  border-radius: 8px;
  border-left: 4px solid #6366f1;
}

.event-text {
  color: #1e293b !important;
  font-weight: 500 !important;
  margin: 0 0 4px 0 !important;
}

.event-time {
  color: #64748b !important;
  font-size: 12px !important;
  margin: 0 !important;
}

.overview-loading, .overview-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
}

.loading-text {
  margin-top: 16px !important;
}

.error-alert {
  margin-bottom: 16px !important;
}

.retry-button {
  background-color: #6366f1 !important;
  color: white !important;
}

.pie-chart-tooltip {
  background-color: white !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
}

.pie-chart-legend {
  padding-top: 20px !important;
}

/***********************/
/* Agents CSS */
/***********************/

.agents {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.agents-header {
  margin-bottom: 32px;
}

.agents-title {
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 8px !important;
}

.agents-subtitle {
  color: #64748b;
}

.agents-loading, .agents-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
}

.agents-controls {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.agents-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-dropdown {
  min-width: 180px;
  background-color: white;
}

.agents-search {
  min-width: 300px;
  background-color: white;
}

.agents-stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.stat-chip {
  font-weight: 500;
}

.stat-chip.total {
  background-color: #e2e8f0 !important;
  color: #475569 !important;
}

.stat-chip.active {
  background-color: #dcfce7 !important;
  color: #166534 !important;
}

.stat-chip.disconnected {
  background-color: #fee2e2 !important;
  color: #991b1b !important;
}

.stat-chip.filtered {
  background-color: #ddd6fe !important;
  color: #5b21b6 !important;
}

.agents-grid {
  margin-bottom: 32px;
}

.agent-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 2px solid transparent;
  height: 100%;
}

.agent-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.agent-card.selected {
  border-color: #6366f1;
  box-shadow: 0 0 0 1px #6366f1;
}

.agent-card-content {
  padding: 20px !important;
}

.agent-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.agent-avatar {
  background-color: #6366f1 !important;
  color: white !important;
  width: 48px !important;
  height: 48px !important;
}

.agent-status {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.status-icon-active {
  color: #10b981 !important;
  font-size: 20px !important;
}

.status-icon-disconnected {
  color: #ef4444 !important;
  font-size: 20px !important;
}

.status-icon-default {
  color: #6b7280 !important;
  font-size: 20px !important;
}

.os-icon {
  color: white !important;
}

.agent-name {
  font-weight: 600 !important;
  color: #1e293b !important;
  margin-bottom: 8px !important;
  font-size: 1.1rem !important;
}

.agent-id, .agent-ip, .agent-os, .agent-version {
  color: #64748b !important;
  margin-bottom: 4px !important;
  font-size: 0.875rem !important;
}

.agent-last-seen {
  color: #9ca3af !important;
  font-size: 0.75rem !important;
  margin-top: 8px !important;
  display: block;
}

.status-chip {
  font-size: 0.75rem !important;
  height: 24px !important;
}

.selected-agent-details {
  margin-top: 32px;
  padding: 24px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.selected-agent-title {
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 24px !important;
}

.agent-details-table {
  border-radius: 8px;
  overflow: hidden;
}

.detail-label {
  font-weight: 600 !important;
  color: #374151 !important;
  background-color: #f9fafb !important;
  width: 200px;
}

.no-agents {
  text-align: center;
  padding: 48px 24px;
  color: #64748b;
}

.no-agents h6 {
  color: #374151;
  margin-bottom: 8px !important;
}

/* Agents Table Styles */
.agents-table-container {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
}

.agents-table {
  min-width: 100%;
}

.table-header {
  background-color: #f8fafc;
}

.table-header-cell {
  font-weight: 600 !important;
  color: #374151 !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px !important;
}

.table-row {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.table-row:hover {
  background-color: #f9fafb;
}

.table-row.selected {
  background-color: #eff6ff;
  border-left: 4px solid #6366f1;
}

.table-cell {
  padding: 16px !important;
  border-bottom: 1px solid #f3f4f6 !important;
}

.agent-name-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-agent-avatar {
  background-color: #6366f1 !important;
  color: white !important;
  width: 40px !important;
  height: 40px !important;
}

.table-agent-name {
  font-weight: 600 !important;
  color: #1e293b !important;
  margin-bottom: 2px !important;
}

.table-agent-id {
  color: #64748b !important;
}

.status-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-status-chip {
  font-size: 0.75rem !important;
  height: 24px !important;
}

.table-ip, .table-os, .table-version, .table-last-seen {
  color: #374151 !important;
  margin-bottom: 2px !important;
}

.table-register-ip, .table-platform, .table-manager, .table-disconnection {
  color: #64748b !important;
  font-size: 0.75rem !important;
}

/***********************/
/* Agent Details CSS */
/***********************/

.agent-details {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.agent-details-loading, .agent-details-error, .agent-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
}

.agent-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.breadcrumbs {
  color: #64748b;
}

.breadcrumb-link {
  cursor: pointer;
  text-decoration: none;
}

.breadcrumb-link:hover {
  text-decoration: underline;
}

.header-actions {
  display: flex;
  gap: 8px;
}

.back-icon-button, .refresh-icon-button {
  background-color: white !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
}

.back-icon-button:hover, .refresh-icon-button:hover {
  background-color: #f8fafc !important;
  color: #374151 !important;
}

.agent-overview-card {
  margin-bottom: 24px;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.agent-overview-content {
  padding: 32px !important;
}

.agent-overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.agent-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.agent-details-avatar {
  background-color: #6366f1 !important;
  color: white !important;
  width: 80px !important;
  height: 80px !important;
  font-size: 2rem !important;
}

.agent-details-name {
  color: #1e293b !important;
  font-weight: 600 !important;
  margin-bottom: 8px !important;
}

.agent-details-id {
  color: #64748b !important;
  font-size: 1.1rem !important;
}

.agent-status-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.agent-details-status-chip {
  font-size: 0.875rem !important;
  height: 32px !important;
  font-weight: 600 !important;
}

.agent-details-grid {
  margin-top: 24px;
}

.details-card {
  height: 100%;
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease-in-out;
}

.details-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.card-icon {
  color: #6366f1 !important;
  font-size: 1.5rem !important;
}

.card-title {
  color: #1e293b !important;
  font-weight: 600 !important;
}

.card-divider {
  margin-bottom: 20px !important;
}

.details-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-label {
  color: #64748b !important;
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}

.detail-value {
  color: #374151 !important;
  font-weight: 500 !important;
}

.system-info, .config-sum {
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  background-color: #f8fafc;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  word-break: break-all;
}

.disconnection-time {
  color: #dc2626 !important;
}

.config-status-chip {
  width: fit-content;
  font-size: 0.75rem !important;
  height: 24px !important;
}

.groups-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.group-chip {
  background-color: #eff6ff !important;
  color: #1d4ed8 !important;
  border-color: #bfdbfe !important;
}

.no-groups {
  color: #9ca3af !important;
  font-style: italic;
  margin-top: 16px;
}

.back-button {
  margin-top: 16px !important;
}

/* Responsive Design for Agent Details */
@media (max-width: 768px) {
  .agent-details {
    padding: 16px;
  }
  
  .agent-details-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .agent-overview-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
  
  .agent-info {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .agent-status-container {
    align-items: center;
  }
  
  .agent-details-avatar {
    width: 60px !important;
    height: 60px !important;
    font-size: 1.5rem !important;
  }
}

/***********************/
/* Alerts CSS */
/***********************/

.alerts {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.alerts-header {
  margin-bottom: 32px;
}

.alerts-title {
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 8px !important;
}

.alerts-subtitle {
  color: #64748b;
}

.alerts-loading, .alerts-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
}

.alerts-controls {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.alerts-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.alerts-search {
  min-width: 300px;
  background-color: white;
}

.alerts-stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.stat-chip.showing {
  background-color: #f0f9ff !important;
  color: #0369a1 !important;
}

.stat-chip.high-level {
  background-color: #fef2f2 !important;
  color: #dc2626 !important;
}

.alerts-table-container {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
}

.alerts-table {
  min-width: 100%;
}

.alert-description-cell {
  max-width: 300px;
}

.alert-description-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alert-description {
  font-weight: 600 !important;
  color: #1e293b !important;
  line-height: 1.4;
}

.alert-log {
  color: #64748b !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  background-color: #f8fafc;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  font-size: 0.75rem !important;
  line-height: 1.3;
}

.alert-groups {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
}

.group-tag {
  background-color: #eff6ff !important;
  color: #1d4ed8 !important;
  font-size: 0.7rem !important;
  height: 20px !important;
}

.more-groups {
  color: #64748b !important;
  font-size: 0.7rem !important;
  margin-left: 4px;
}

.level-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.level-icon-info {
  color: #0ea5e9 !important;
  font-size: 18px !important;
}

.level-icon-warning {
  color: #f59e0b !important;
  font-size: 18px !important;
}

.level-icon-error {
  color: #ef4444 !important;
  font-size: 18px !important;
}

.level-icon-critical {
  color: #dc2626 !important;
  font-size: 18px !important;
}

.level-chip {
  font-size: 0.75rem !important;
  height: 24px !important;
}

.agent-info-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.agent-name-ip {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.agent-name {
  font-weight: 600 !important;
  color: #1e293b !important;
}

.agent-ip, .agent-id {
  color: #64748b !important;
  font-size: 0.75rem !important;
}

.rule-info-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rule-id {
  font-weight: 600 !important;
  color: #1e293b !important;
}

.rule-fired, .mitre-info {
  color: #64748b !important;
  font-size: 0.75rem !important;
}

.mitre-info {
  color: #7c3aed !important;
  font-weight: 500 !important;
}

.location-info-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.location-path {
  color: #374151 !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
  font-size: 0.875rem !important;
}

.geo-location {
  display: flex;
  align-items: center;
  gap: 4px;
}

.location-icon {
  color: #10b981 !important;
  font-size: 14px !important;
}

.geo-info {
  color: #059669 !important;
  font-size: 0.75rem !important;
}

.timestamp-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.timestamp-icon {
  color: #6b7280 !important;
  font-size: 16px !important;
}

.timestamp {
  color: #374151 !important;
  font-size: 0.875rem !important;
}

.no-alerts {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #64748b;
}

.no-alerts-icon {
  font-size: 3rem !important;
  color: #9ca3af !important;
  margin-bottom: 16px;
}

.no-alerts h6 {
  color: #374151;
  margin-bottom: 8px !important;
}

.alerts-pagination {
  margin-top: 24px;
  padding: 16px 24px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.pagination-info {
  color: #64748b !important;
  font-weight: 500 !important;
}

/***********************/
/* Compliance CSS */
/***********************/

.compliance {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.compliance-header {
  margin-bottom: 32px;
}

.compliance-title {
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 8px !important;
}

.compliance-subtitle {
  color: #64748b;
}

.compliance-loading, .compliance-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
}

.compliance-controls {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.compliance-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.compliance-search {
  min-width: 300px;
  background-color: white;
}

.compliance-stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.compliance-chart-card, .compliance-summary-card {
  border-radius: 12px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  margin-bottom: 24px;
}

.compliance-summary-stats {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.summary-stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e2e8f0;
}

.summary-stat-item:last-child {
  border-bottom: none;
}

.stat-label {
  color: #64748b !important;
  font-weight: 500 !important;
}

.stat-values {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.stat-count {
  color: #1e293b !important;
  font-weight: 600 !important;
}

.stat-percentage {
  color: #6366f1 !important;
  font-weight: 500 !important;
}

.no-compliance {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #64748b;
}

.no-compliance-icon {
  font-size: 3rem !important;
  color: #9ca3af !important;
  margin-bottom: 16px;
}

.no-compliance h6 {
  color: #374151;
  margin-bottom: 8px !important;
}

/***********************/
/* Vulnerabilities CSS */
/***********************/

.vulnerabilities {
  padding: 24px;
  background-color: #f8fafc;
  min-height: 100vh;
}

.vulnerabilities-header {
  margin-bottom: 32px;
}

.vulnerabilities-title {
  color: #1e293b;
  font-weight: 600;
  margin-bottom: 8px !important;
}

.vulnerabilities-subtitle {
  color: #64748b;
}

.vulnerabilities-loading, .vulnerabilities-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
}

.vulnerabilities-controls {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.vulnerabilities-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.vulnerabilities-search {
  min-width: 300px;
  background-color: white;
}

.vulnerabilities-stats {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.stat-chip.critical-vuln {
  background-color: #fef2f2 !important;
  color: #dc2626 !important;
}

.vulnerabilities-table-container {
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 32px;
}

.vulnerabilities-table {
  min-width: 100%;
}

.vulnerability-description-cell {
  max-width: 300px;
}

.vulnerability-description-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vulnerability-title {
  font-weight: 600 !important;
  color: #1e293b !important;
  line-height: 1.4;
}

.vulnerability-description {
  color: #64748b !important;
  font-size: 0.875rem !important;
  line-height: 1.3;
}

.severity-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.severity-icon-info {
  color: #0ea5e9 !important;
  font-size: 18px !important;
}

.severity-icon-warning {
  color: #f59e0b !important;
  font-size: 18px !important;
}

.severity-icon-error {
  color: #ef4444 !important;
  font-size: 18px !important;
}

.severity-icon-critical {
  color: #dc2626 !important;
  font-size: 18px !important;
}

.severity-chip {
  font-size: 0.75rem !important;
  height: 24px !important;
}

.package-info-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.package-name {
  font-weight: 600 !important;
  color: #1e293b !important;
}

.package-version {
  color: #64748b !important;
  font-size: 0.75rem !important;
}

.cve-info-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.cve-id {
  font-weight: 600 !important;
  color: #1e293b !important;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

.cvss-score {
  color: #7c3aed !important;
  font-size: 0.75rem !important;
  font-weight: 500 !important;
}

.vulnerabilities-pagination {
  margin-top: 24px;
  padding: 16px 24px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.no-vulnerabilities {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #64748b;
}

.no-vulnerabilities-icon {
  font-size: 3rem !important;
  color: #9ca3af !important;
  margin-bottom: 16px;
}

.no-vulnerabilities h6 {
  color: #374151;
  margin-bottom: 8px !important;
}

/***********************/
/* Dashboard CSS (Legacy) */
/***********************/

.dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.dashboard-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem 2rem;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #1f2937;
}

.header-title h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.refresh-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.dashboard-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
}

.dashboard .stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.dashboard .stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 1rem;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.dashboard .stat-card:hover {
  transform: translateY(-2px);
}

.dashboard .stat-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5e7eb;
  color: #6b7280;
}

.dashboard .stat-icon.active {
  background: #dcfce7;
  color: #16a34a;
}

.dashboard .stat-icon.warning {
  background: #fef3c7;
  color: #d97706;
}

.dashboard .stat-icon.critical {
  background: #fee2e2;
  color: #dc2626;
}

.dashboard .stat-info h3 {
  margin: 0 0 0.25rem 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.dashboard .stat-number {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
}

.agents-section, .alerts-section {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 1rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.agents-section h2, .alerts-section h2 {
  margin: 0 0 1.5rem 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
}

.agents-table-container {
  overflow-x: auto;
}

.agents-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.agents-table th {
  background: #f9fafb;
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.agents-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #f3f4f6;
  color: #1f2937;
}

.agent-row:hover {
  background: #f9fafb;
}

.agent-id {
  font-weight: 600;
  color: #3b82f6;
}

.agent-name {
  font-weight: 500;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.view-btn {
  padding: 0.375rem 0.75rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}

.view-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.alerts-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.alert-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 0.5rem;
  border-left: 4px solid #3b82f6;
}

.alert-info h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

.alert-info p {
  margin: 0.25rem 0;
  font-size: 0.875rem;
  color: #6b7280;
}

.severity-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.severity-low, .severity-1, .severity-2, .severity-3 {
  background: #dcfce7;
  color: #16a34a;
}

.severity-medium, .severity-4, .severity-5, .severity-6, .severity-7 {
  background: #fef3c7;
  color: #d97706;
}

.severity-high, .severity-8, .severity-9, .severity-10, .severity-15 {
  background: #fee2e2;
  color: #dc2626;
}

.dashboard-loading, .dashboard-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  color: white;
  gap: 1rem;
}

.dashboard-loading p, .dashboard-error p {
  font-size: 1.125rem;
  margin: 0;
}

.retry-btn {
  padding: 0.75rem 1.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.retry-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/***********************/
/* Responsive Design */
/***********************/

@media (max-width: 1200px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .charts-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
  
  .overview {
    padding: 16px;
  }
  
  .overview-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .dashboard-content {
    padding: 1rem;
  }
  
  .agents-table-container {
    font-size: 0.875rem;
  }
  
  .alert-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB,mBAAmB;AACnB,wBAAwB;;AAExB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,iBAAiB;EACjB,UAAU;AACZ;;AAEA,wBAAwB;AACxB,gBAAgB;AAChB,wBAAwB;;AAExB;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB,iBAAiB;AACjB,wBAAwB;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,qDAAqD;EACrD,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wBAAwB;AACxB,eAAe;AACf,wBAAwB;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB,sBAAsB;AACtB,wBAAwB;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,mDAAmD;EACnD,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mEAAmE;EACnE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA,wBAAwB;AACxB,eAAe;AACf,wBAAwB;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB,mBAAmB;AACnB,wBAAwB;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB,2BAA2B;AAC3B,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,wBAAwB;AACxB,sBAAsB;AACtB,wBAAwB;;AAExB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f8fafc;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n/***********************/\n/* MainLayout CSS */\n/***********************/\n\n.main-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  background-color: #f1f5f9;\n  min-height: 100vh;\n  padding: 0;\n}\n\n/***********************/\n/* Sidebar CSS */\n/***********************/\n\n.sidebar .MuiDrawer-paper {\n  background: #4a5568 !important;\n  color: white !important;\n  border-right: none !important;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 20px;\n  background: #2d3748;\n  border-bottom: 1px solid #4a5568;\n}\n\n.sidebar-logo {\n  color: #6366f1 !important;\n  font-size: 28px !important;\n}\n\n.sidebar-title {\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  color: white !important;\n  margin: 0 !important;\n  line-height: 1.2 !important;\n}\n\n.sidebar-subtitle {\n  font-size: 14px !important;\n  color: #a0aec0 !important;\n  margin: 0 !important;\n  line-height: 1 !important;\n}\n\n.sidebar-menu {\n  padding: 16px 0 !important;\n}\n\n.sidebar-menu-item {\n  margin: 4px 16px !important;\n  border-radius: 8px !important;\n  color: #e2e8f0 !important;\n  transition: all 0.2s ease !important;\n}\n\n.sidebar-menu-item:hover {\n  background-color: #2d3748 !important;\n  color: white !important;\n}\n\n.sidebar-menu-item.active {\n  background-color: #6366f1 !important;\n  color: white !important;\n}\n\n.sidebar-menu-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n}\n\n.sidebar-menu-icon {\n  color: inherit !important;\n  min-width: 40px !important;\n}\n\n.sidebar-menu-text .MuiTypography-root {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n/***********************/\n/* Overview CSS */\n/***********************/\n\n.overview {\n  padding: 32px;\n  background-color: #f1f5f9;\n  min-height: 100vh;\n  margin: 0;\n}\n\n.overview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.overview-title {\n  font-size: 32px !important;\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  margin: 0 !important;\n}\n\n.overview-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.agent-selector {\n  color: #64748b !important;\n  font-size: 14px !important;\n}\n\n.refresh-button {\n  background-color: #6366f1 !important;\n  color: white !important;\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n}\n\n.refresh-button:hover {\n  background-color: #5856eb !important;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white !important;\n  border-radius: 12px !important;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;\n  border: 1px solid #e2e8f0 !important;\n  transition: all 0.2s ease !important;\n}\n\n.stat-card:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;\n  transform: translateY(-2px);\n}\n\n.stat-card.total-agents .stat-number {\n  color: #64748b;\n  font-size: 48px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.stat-card.active-agents {\n  border-left: 4px solid #10b981 !important;\n}\n\n.stat-card.active-agents .stat-icon {\n  color: #10b981 !important;\n}\n\n.stat-card.active-agents .stat-number {\n  color: #10b981;\n  font-size: 48px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.stat-card.security-alerts {\n  border-left: 4px solid #f59e0b !important;\n}\n\n.stat-card.security-alerts .stat-icon {\n  color: #f59e0b !important;\n}\n\n.stat-card.security-alerts .stat-number {\n  color: #f59e0b;\n  font-size: 48px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.stat-card.disconnected {\n  border-left: 4px solid #ef4444 !important;\n}\n\n.stat-card.disconnected .stat-number {\n  color: #ef4444;\n  font-size: 48px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 8px;\n}\n\n.stat-icon {\n  font-size: 24px !important;\n  margin-bottom: 8px;\n}\n\n.stat-label {\n  color: #64748b !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  margin: 8px 0 0 0 !important;\n}\n\n.charts-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.chart-card {\n  background: white !important;\n  border-radius: 12px !important;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1) !important;\n  border: 1px solid #e2e8f0 !important;\n}\n\n.chart-title {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  margin-bottom: 16px !important;\n}\n\n.chart-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  background-color: #f8fafc;\n  border-radius: 8px;\n  border: 2px dashed #cbd5e1;\n}\n\n.pie-chart-container {\n  width: 100%;\n  height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.pie-chart-container:hover {\n  transform: translateY(-2px);\n}\n\n.pie-chart-container .recharts-legend-wrapper {\n  padding-top: 20px !important;\n}\n\n.pie-chart-container .recharts-legend-item-text {\n  color: #1e293b !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n.pie-chart-container .recharts-pie-sector {\n  transition: all 0.3s ease !important;\n  cursor: default !important;\n}\n\n.pie-chart-container .recharts-pie-sector:hover {\n  filter: brightness(1.1);\n  transform: scale(1.02);\n}\n\n.events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.event-item {\n  padding: 12px;\n  background-color: #f8fafc;\n  border-radius: 8px;\n  border-left: 4px solid #6366f1;\n}\n\n.event-text {\n  color: #1e293b !important;\n  font-weight: 500 !important;\n  margin: 0 0 4px 0 !important;\n}\n\n.event-time {\n  color: #64748b !important;\n  font-size: 12px !important;\n  margin: 0 !important;\n}\n\n.overview-loading, .overview-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n}\n\n.loading-text {\n  margin-top: 16px !important;\n}\n\n.error-alert {\n  margin-bottom: 16px !important;\n}\n\n.retry-button {\n  background-color: #6366f1 !important;\n  color: white !important;\n}\n\n.pie-chart-tooltip {\n  background-color: white !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;\n}\n\n.pie-chart-legend {\n  padding-top: 20px !important;\n}\n\n/***********************/\n/* Agents CSS */\n/***********************/\n\n.agents {\n  padding: 24px;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n.agents-header {\n  margin-bottom: 32px;\n}\n\n.agents-title {\n  color: #1e293b;\n  font-weight: 600;\n  margin-bottom: 8px !important;\n}\n\n.agents-subtitle {\n  color: #64748b;\n}\n\n.agents-loading, .agents-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n}\n\n.agents-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.agents-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.filter-dropdown {\n  min-width: 180px;\n  background-color: white;\n}\n\n.agents-search {\n  min-width: 300px;\n  background-color: white;\n}\n\n.agents-stats {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.stat-chip {\n  font-weight: 500;\n}\n\n.stat-chip.total {\n  background-color: #e2e8f0 !important;\n  color: #475569 !important;\n}\n\n.stat-chip.active {\n  background-color: #dcfce7 !important;\n  color: #166534 !important;\n}\n\n.stat-chip.disconnected {\n  background-color: #fee2e2 !important;\n  color: #991b1b !important;\n}\n\n.stat-chip.filtered {\n  background-color: #ddd6fe !important;\n  color: #5b21b6 !important;\n}\n\n.agents-grid {\n  margin-bottom: 32px;\n}\n\n.agent-card {\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  border: 2px solid transparent;\n  height: 100%;\n}\n\n.agent-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.agent-card.selected {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 1px #6366f1;\n}\n\n.agent-card-content {\n  padding: 20px !important;\n}\n\n.agent-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.agent-avatar {\n  background-color: #6366f1 !important;\n  color: white !important;\n  width: 48px !important;\n  height: 48px !important;\n}\n\n.agent-status {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.status-icon-active {\n  color: #10b981 !important;\n  font-size: 20px !important;\n}\n\n.status-icon-disconnected {\n  color: #ef4444 !important;\n  font-size: 20px !important;\n}\n\n.status-icon-default {\n  color: #6b7280 !important;\n  font-size: 20px !important;\n}\n\n.os-icon {\n  color: white !important;\n}\n\n.agent-name {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  margin-bottom: 8px !important;\n  font-size: 1.1rem !important;\n}\n\n.agent-id, .agent-ip, .agent-os, .agent-version {\n  color: #64748b !important;\n  margin-bottom: 4px !important;\n  font-size: 0.875rem !important;\n}\n\n.agent-last-seen {\n  color: #9ca3af !important;\n  font-size: 0.75rem !important;\n  margin-top: 8px !important;\n  display: block;\n}\n\n.status-chip {\n  font-size: 0.75rem !important;\n  height: 24px !important;\n}\n\n.selected-agent-details {\n  margin-top: 32px;\n  padding: 24px;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.selected-agent-title {\n  color: #1e293b;\n  font-weight: 600;\n  margin-bottom: 24px !important;\n}\n\n.agent-details-table {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.detail-label {\n  font-weight: 600 !important;\n  color: #374151 !important;\n  background-color: #f9fafb !important;\n  width: 200px;\n}\n\n.no-agents {\n  text-align: center;\n  padding: 48px 24px;\n  color: #64748b;\n}\n\n.no-agents h6 {\n  color: #374151;\n  margin-bottom: 8px !important;\n}\n\n/* Agents Table Styles */\n.agents-table-container {\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 32px;\n}\n\n.agents-table {\n  min-width: 100%;\n}\n\n.table-header {\n  background-color: #f8fafc;\n}\n\n.table-header-cell {\n  font-weight: 600 !important;\n  color: #374151 !important;\n  border-bottom: 2px solid #e5e7eb !important;\n  padding: 16px !important;\n}\n\n.table-row {\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.table-row:hover {\n  background-color: #f9fafb;\n}\n\n.table-row.selected {\n  background-color: #eff6ff;\n  border-left: 4px solid #6366f1;\n}\n\n.table-cell {\n  padding: 16px !important;\n  border-bottom: 1px solid #f3f4f6 !important;\n}\n\n.agent-name-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.table-agent-avatar {\n  background-color: #6366f1 !important;\n  color: white !important;\n  width: 40px !important;\n  height: 40px !important;\n}\n\n.table-agent-name {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  margin-bottom: 2px !important;\n}\n\n.table-agent-id {\n  color: #64748b !important;\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.table-status-chip {\n  font-size: 0.75rem !important;\n  height: 24px !important;\n}\n\n.table-ip, .table-os, .table-version, .table-last-seen {\n  color: #374151 !important;\n  margin-bottom: 2px !important;\n}\n\n.table-register-ip, .table-platform, .table-manager, .table-disconnection {\n  color: #64748b !important;\n  font-size: 0.75rem !important;\n}\n\n/***********************/\n/* Agent Details CSS */\n/***********************/\n\n.agent-details {\n  padding: 24px;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n.agent-details-loading, .agent-details-error, .agent-not-found {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n}\n\n.agent-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.breadcrumbs {\n  color: #64748b;\n}\n\n.breadcrumb-link {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.breadcrumb-link:hover {\n  text-decoration: underline;\n}\n\n.header-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.back-icon-button, .refresh-icon-button {\n  background-color: white !important;\n  border: 1px solid #e2e8f0 !important;\n  color: #64748b !important;\n}\n\n.back-icon-button:hover, .refresh-icon-button:hover {\n  background-color: #f8fafc !important;\n  color: #374151 !important;\n}\n\n.agent-overview-card {\n  margin-bottom: 24px;\n  border-radius: 12px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n}\n\n.agent-overview-content {\n  padding: 32px !important;\n}\n\n.agent-overview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.agent-info {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.agent-details-avatar {\n  background-color: #6366f1 !important;\n  color: white !important;\n  width: 80px !important;\n  height: 80px !important;\n  font-size: 2rem !important;\n}\n\n.agent-details-name {\n  color: #1e293b !important;\n  font-weight: 600 !important;\n  margin-bottom: 8px !important;\n}\n\n.agent-details-id {\n  color: #64748b !important;\n  font-size: 1.1rem !important;\n}\n\n.agent-status-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.agent-details-status-chip {\n  font-size: 0.875rem !important;\n  height: 32px !important;\n  font-weight: 600 !important;\n}\n\n.agent-details-grid {\n  margin-top: 24px;\n}\n\n.details-card {\n  height: 100%;\n  border-radius: 12px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n  transition: all 0.2s ease-in-out;\n}\n\n.details-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.card-icon {\n  color: #6366f1 !important;\n  font-size: 1.5rem !important;\n}\n\n.card-title {\n  color: #1e293b !important;\n  font-weight: 600 !important;\n}\n\n.card-divider {\n  margin-bottom: 20px !important;\n}\n\n.details-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.detail-label {\n  color: #64748b !important;\n  font-weight: 500 !important;\n  font-size: 0.875rem !important;\n}\n\n.detail-value {\n  color: #374151 !important;\n  font-weight: 500 !important;\n}\n\n.system-info, .config-sum {\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n  background-color: #f8fafc;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  word-break: break-all;\n}\n\n.disconnection-time {\n  color: #dc2626 !important;\n}\n\n.config-status-chip {\n  width: fit-content;\n  font-size: 0.75rem !important;\n  height: 24px !important;\n}\n\n.groups-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.group-chip {\n  background-color: #eff6ff !important;\n  color: #1d4ed8 !important;\n  border-color: #bfdbfe !important;\n}\n\n.no-groups {\n  color: #9ca3af !important;\n  font-style: italic;\n  margin-top: 16px;\n}\n\n.back-button {\n  margin-top: 16px !important;\n}\n\n/* Responsive Design for Agent Details */\n@media (max-width: 768px) {\n  .agent-details {\n    padding: 16px;\n  }\n  \n  .agent-details-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .agent-overview-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n  }\n  \n  .agent-info {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .agent-status-container {\n    align-items: center;\n  }\n  \n  .agent-details-avatar {\n    width: 60px !important;\n    height: 60px !important;\n    font-size: 1.5rem !important;\n  }\n}\n\n/***********************/\n/* Alerts CSS */\n/***********************/\n\n.alerts {\n  padding: 24px;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n.alerts-header {\n  margin-bottom: 32px;\n}\n\n.alerts-title {\n  color: #1e293b;\n  font-weight: 600;\n  margin-bottom: 8px !important;\n}\n\n.alerts-subtitle {\n  color: #64748b;\n}\n\n.alerts-loading, .alerts-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n}\n\n.alerts-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.alerts-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.alerts-search {\n  min-width: 300px;\n  background-color: white;\n}\n\n.alerts-stats {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.stat-chip.showing {\n  background-color: #f0f9ff !important;\n  color: #0369a1 !important;\n}\n\n.stat-chip.high-level {\n  background-color: #fef2f2 !important;\n  color: #dc2626 !important;\n}\n\n.alerts-table-container {\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 32px;\n}\n\n.alerts-table {\n  min-width: 100%;\n}\n\n.alert-description-cell {\n  max-width: 300px;\n}\n\n.alert-description-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.alert-description {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  line-height: 1.4;\n}\n\n.alert-log {\n  color: #64748b !important;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n  background-color: #f8fafc;\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n  font-size: 0.75rem !important;\n  line-height: 1.3;\n}\n\n.alert-groups {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  align-items: center;\n}\n\n.group-tag {\n  background-color: #eff6ff !important;\n  color: #1d4ed8 !important;\n  font-size: 0.7rem !important;\n  height: 20px !important;\n}\n\n.more-groups {\n  color: #64748b !important;\n  font-size: 0.7rem !important;\n  margin-left: 4px;\n}\n\n.level-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.level-icon-info {\n  color: #0ea5e9 !important;\n  font-size: 18px !important;\n}\n\n.level-icon-warning {\n  color: #f59e0b !important;\n  font-size: 18px !important;\n}\n\n.level-icon-error {\n  color: #ef4444 !important;\n  font-size: 18px !important;\n}\n\n.level-icon-critical {\n  color: #dc2626 !important;\n  font-size: 18px !important;\n}\n\n.level-chip {\n  font-size: 0.75rem !important;\n  height: 24px !important;\n}\n\n.agent-info-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.agent-name-ip {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.agent-name {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n}\n\n.agent-ip, .agent-id {\n  color: #64748b !important;\n  font-size: 0.75rem !important;\n}\n\n.rule-info-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.rule-id {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n}\n\n.rule-fired, .mitre-info {\n  color: #64748b !important;\n  font-size: 0.75rem !important;\n}\n\n.mitre-info {\n  color: #7c3aed !important;\n  font-weight: 500 !important;\n}\n\n.location-info-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.location-path {\n  color: #374151 !important;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n  font-size: 0.875rem !important;\n}\n\n.geo-location {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.location-icon {\n  color: #10b981 !important;\n  font-size: 14px !important;\n}\n\n.geo-info {\n  color: #059669 !important;\n  font-size: 0.75rem !important;\n}\n\n.timestamp-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.timestamp-icon {\n  color: #6b7280 !important;\n  font-size: 16px !important;\n}\n\n.timestamp {\n  color: #374151 !important;\n  font-size: 0.875rem !important;\n}\n\n.no-alerts {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  color: #64748b;\n}\n\n.no-alerts-icon {\n  font-size: 3rem !important;\n  color: #9ca3af !important;\n  margin-bottom: 16px;\n}\n\n.no-alerts h6 {\n  color: #374151;\n  margin-bottom: 8px !important;\n}\n\n.alerts-pagination {\n  margin-top: 24px;\n  padding: 16px 24px;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.pagination-info {\n  color: #64748b !important;\n  font-weight: 500 !important;\n}\n\n/***********************/\n/* Compliance CSS */\n/***********************/\n\n.compliance {\n  padding: 24px;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n.compliance-header {\n  margin-bottom: 32px;\n}\n\n.compliance-title {\n  color: #1e293b;\n  font-weight: 600;\n  margin-bottom: 8px !important;\n}\n\n.compliance-subtitle {\n  color: #64748b;\n}\n\n.compliance-loading, .compliance-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n}\n\n.compliance-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.compliance-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.compliance-search {\n  min-width: 300px;\n  background-color: white;\n}\n\n.compliance-stats {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.compliance-chart-card, .compliance-summary-card {\n  border-radius: 12px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;\n  margin-bottom: 24px;\n}\n\n.compliance-summary-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.summary-stat-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.summary-stat-item:last-child {\n  border-bottom: none;\n}\n\n.stat-label {\n  color: #64748b !important;\n  font-weight: 500 !important;\n}\n\n.stat-values {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.stat-count {\n  color: #1e293b !important;\n  font-weight: 600 !important;\n}\n\n.stat-percentage {\n  color: #6366f1 !important;\n  font-weight: 500 !important;\n}\n\n.no-compliance {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  color: #64748b;\n}\n\n.no-compliance-icon {\n  font-size: 3rem !important;\n  color: #9ca3af !important;\n  margin-bottom: 16px;\n}\n\n.no-compliance h6 {\n  color: #374151;\n  margin-bottom: 8px !important;\n}\n\n/***********************/\n/* Vulnerabilities CSS */\n/***********************/\n\n.vulnerabilities {\n  padding: 24px;\n  background-color: #f8fafc;\n  min-height: 100vh;\n}\n\n.vulnerabilities-header {\n  margin-bottom: 32px;\n}\n\n.vulnerabilities-title {\n  color: #1e293b;\n  font-weight: 600;\n  margin-bottom: 8px !important;\n}\n\n.vulnerabilities-subtitle {\n  color: #64748b;\n}\n\n.vulnerabilities-loading, .vulnerabilities-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n}\n\n.vulnerabilities-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.vulnerabilities-filters {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.vulnerabilities-search {\n  min-width: 300px;\n  background-color: white;\n}\n\n.vulnerabilities-stats {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.stat-chip.critical-vuln {\n  background-color: #fef2f2 !important;\n  color: #dc2626 !important;\n}\n\n.vulnerabilities-table-container {\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin-bottom: 32px;\n}\n\n.vulnerabilities-table {\n  min-width: 100%;\n}\n\n.vulnerability-description-cell {\n  max-width: 300px;\n}\n\n.vulnerability-description-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vulnerability-title {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  line-height: 1.4;\n}\n\n.vulnerability-description {\n  color: #64748b !important;\n  font-size: 0.875rem !important;\n  line-height: 1.3;\n}\n\n.severity-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.severity-icon-info {\n  color: #0ea5e9 !important;\n  font-size: 18px !important;\n}\n\n.severity-icon-warning {\n  color: #f59e0b !important;\n  font-size: 18px !important;\n}\n\n.severity-icon-error {\n  color: #ef4444 !important;\n  font-size: 18px !important;\n}\n\n.severity-icon-critical {\n  color: #dc2626 !important;\n  font-size: 18px !important;\n}\n\n.severity-chip {\n  font-size: 0.75rem !important;\n  height: 24px !important;\n}\n\n.package-info-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.package-name {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n}\n\n.package-version {\n  color: #64748b !important;\n  font-size: 0.75rem !important;\n}\n\n.cve-info-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.cve-id {\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;\n}\n\n.cvss-score {\n  color: #7c3aed !important;\n  font-size: 0.75rem !important;\n  font-weight: 500 !important;\n}\n\n.vulnerabilities-pagination {\n  margin-top: 24px;\n  padding: 16px 24px;\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.no-vulnerabilities {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  color: #64748b;\n}\n\n.no-vulnerabilities-icon {\n  font-size: 3rem !important;\n  color: #9ca3af !important;\n  margin-bottom: 16px;\n}\n\n.no-vulnerabilities h6 {\n  color: #374151;\n  margin-bottom: 8px !important;\n}\n\n/***********************/\n/* Dashboard CSS (Legacy) */\n/***********************/\n\n.dashboard {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n.dashboard-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 1rem 2rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.header-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: #1f2937;\n}\n\n.header-title h1 {\n  margin: 0;\n  font-size: 1.75rem;\n  font-weight: 700;\n}\n\n.refresh-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.refresh-btn:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.dashboard-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.dashboard .stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.dashboard .stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s;\n}\n\n.dashboard .stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.dashboard .stat-icon {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #e5e7eb;\n  color: #6b7280;\n}\n\n.dashboard .stat-icon.active {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.dashboard .stat-icon.warning {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.dashboard .stat-icon.critical {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.dashboard .stat-info h3 {\n  margin: 0 0 0.25rem 0;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.dashboard .stat-number {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.agents-section, .alerts-section {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 1rem;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.agents-section h2, .alerts-section h2 {\n  margin: 0 0 1.5rem 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.agents-table-container {\n  overflow-x: auto;\n}\n\n.agents-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.agents-table th {\n  background: #f9fafb;\n  padding: 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.agents-table td {\n  padding: 0.75rem;\n  border-bottom: 1px solid #f3f4f6;\n  color: #1f2937;\n}\n\n.agent-row:hover {\n  background: #f9fafb;\n}\n\n.agent-id {\n  font-weight: 600;\n  color: #3b82f6;\n}\n\n.agent-name {\n  font-weight: 500;\n}\n\n.status-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.view-btn {\n  padding: 0.375rem 0.75rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.view-btn:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.alerts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.alert-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 0.5rem;\n  border-left: 4px solid #3b82f6;\n}\n\n.alert-info h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.alert-info p {\n  margin: 0.25rem 0;\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.severity-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.severity-low, .severity-1, .severity-2, .severity-3 {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.severity-medium, .severity-4, .severity-5, .severity-6, .severity-7 {\n  background: #fef3c7;\n  color: #d97706;\n}\n\n.severity-high, .severity-8, .severity-9, .severity-10, .severity-15 {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.dashboard-loading, .dashboard-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  color: white;\n  gap: 1rem;\n}\n\n.dashboard-loading p, .dashboard-error p {\n  font-size: 1.125rem;\n  margin: 0;\n}\n\n.retry-btn {\n  padding: 0.75rem 1.5rem;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.retry-btn:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/***********************/\n/* Responsive Design */\n/***********************/\n\n@media (max-width: 1200px) {\n  .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  \n  .charts-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n  }\n  \n  .overview {\n    padding: 16px;\n  }\n  \n  .overview-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .dashboard-content {\n    padding: 1rem;\n  }\n  \n  .agents-table-container {\n    font-size: 0.875rem;\n  }\n  \n  .alert-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
